import { lazy, Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';
import LoaderText from '../components/loader/LoaderText';
import Error404 from '../pages/error/Error404';
import { NAVIGATE_REGISTER } from '../constant';

const GuestLayout = lazy(() => import('../layout/GuestLayout'));
const HospitalRegister = lazy(() => import('../pages/auth/register/hospital'));
const BloodBankRegister = lazy(() => import('../pages/auth/register/blood-bank'));


const RegisterRoute = () => {
    return (
        <Suspense fallback={<GuestLayout><LoaderText /></GuestLayout>}>
            <GuestLayout>
                <Routes>
                    <Route path='*' element={<Error404 />}></Route>
                    <Route path={NAVIGATE_REGISTER.HOSPITAL_REGISTER} element={<HospitalRegister />}></Route>
                    <Route path={NAVIGATE_REGISTER.HOSPITAL_UPDATE} element={<HospitalRegister />}></Route>
                    <Route path={NAVIGATE_REGISTER.BLOOD_BANK_REGISTER} element={<BloodBankRegister />}></Route>
                    <Route path={NAVIGATE_REGISTER.BLOOD_BANK_UPDATE} element={<BloodBankRegister />}></Route>
                </Routes>
            </GuestLayout>
        </Suspense>
    )
}

export default RegisterRoute;